import { gql } from '@apollo/client';
import React from 'react';
import type { CommentThreadCompactAvatarStack_UserFragment } from '../../graphql/generated/graphqlTypes';
import CommentThreadCompactAvatar from './CommentThreadCompactAvatar';
import styles from './CommentThreadCompactAvatarStack.module.scss';

const USER_FRAGMENT = gql`
  fragment CommentThreadCompactAvatarStack_user on User {
    ...CommentThreadCompactAvatar_user
  }
  ${CommentThreadCompactAvatar.fragments.user}
`;

interface CommentThreadCompactAvatarStackProps {
  items: Array<
    | { author: CommentThreadCompactAvatarStack_UserFragment; emoji?: string }
    | number
  >;
  ring: boolean;
}

const CommentThreadCompactAvatarStack = ({
  items,
  ring,
}: CommentThreadCompactAvatarStackProps) => (
  <div className={styles.container}>
    {items.map((item, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className={styles.avatarContainer} key={i}>
        {typeof item === 'number' ? (
          <div className={styles.counter}>{item}</div>
        ) : (
          <CommentThreadCompactAvatar
            ring={ring}
            user={item.author}
            emoji={item.emoji}
          />
        )}
      </div>
    ))}
  </div>
);

CommentThreadCompactAvatarStack.fragments = { user: USER_FRAGMENT };

export default CommentThreadCompactAvatarStack;
